import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

import { navigation } from 'app/navigation/navigation';
import { locale as navigationEnglish } from 'app/navigation/i18n/en';
import { locale as navigationTurkish } from 'app/navigation/i18n/tr';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { RoleAuthGuardService } from './role-auth-guard.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { timezones } from '@fuse/utils/timezones';
import { CommonService } from '@fuse/services/common.service';
import { CryptoService } from '@fuse/services/crypto.service';
import { environment } from 'environments/environment';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    fuseConfig: any;
    navigation: any;
    timeZones = timezones;
    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {DOCUMENT} document
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {FuseSplashScreenService} _fuseSplashScreenService
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * @param {Platform} _platform
     * @param {TranslateService} _translateService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _RoleAuthGuardService: RoleAuthGuardService,
        private _translateService: TranslateService,
        private _commonService: CommonService,
        private _platform: Platform,
        private router: Router,
        private cryptoService: CryptoService,
    ) {

        // console.log = function () { };
        // console.error = function () { };
        // console.warn = function () { };
        // console.info = function () { };

        // localStorage.setItem('selectedTimeZone', JSON.stringify(this.selectedTimeZone));
        // JSON.parse(localStorage.getItem('selectedTimeZone'))

        // this._ToolbarService._selectedTimeZone.next(zone);

        // BUILD INFO TO CHECK BUILD WAS UPLOADED OR NOT.
        console.log("certificate Tool update");

        const timeZone: any = new Intl.DateTimeFormat().resolvedOptions().timeZone;
        const locationTimeZone: any = this.timeZones.filter((zone) => zone.utc.find((item) => item == String(timeZone)))[0];
        this._commonService._selectedTimeZone.next(locationTimeZone)


        // Get default navigation
        this.navigation = navigation;

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        // Add languages
        this._translateService.addLangs(['en', 'tr']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix Start
         * ----------------------------------------------------------------------------------------------------
         */

        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         **/

        // Set the default language to 'en' and then back to 'tr'.
        // '.use' cannot be used here as ngxTranslate won't switch to a language that's already
        // been selected and there is no way to force it, so we overcome the issue by switching
        // the default language back and forth.
        /**
         setTimeout(() => {
            this._translateService.setDefaultLang('en');
            this._translateService.setDefaultLang('tr');
         });
         */

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix End
         * ----------------------------------------------------------------------------------------------------
         */

        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }

        this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                let checker = String(val.url).match('/home')
                if (checker?.length) {
                    this._RoleAuthGuardService.toolbarVisible.next(true);
                } else {
                    this._RoleAuthGuardService.toolbarVisible.next(false);
                }
            }
        })

        // Set the private defaults
        this._unsubscribeAll = new Subject();



        // router.events
        // .filter(event => event instanceof NavigationEnd)
        // .subscribe(e => {
        //   console.log('prev:', this.previousUrl);
        //   this.previousUrl = e.url;
        // });

        // this.router.events.subscribe(event => {

        //     console.log('***-0',event)
        //     if(event instanceof NavigationStart){
        //         if(event.url =='/distributors')

        //     }
        // //     if (event instanceof RouteConfigLoadStart || event instanceof ResolveStart) {
        // //      this.sidebarService.commonSidebar = false;
        // //      this.sidebarService.IsLoaderShow = true;
        // //    }
        // //    if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        // //      setTimeout(() => {
        // //        this.sidebarService.IsLoaderShow = false;
        // //      }, 500);
        // //    }
        //  });


    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.fuseConfig = config;

                // Boxed
                if (this.fuseConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                }
                else {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];

                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });

    }

    // encrypt() {
    //     const data = 'hello there';
    //     console.log("encrypt", this.cryptoService.encryptData(data));
    // }

    // decrypt() {
    //     console.log("decrypt", this.cryptoService.decryptData('9d8759ec7b914211bbb6ca50fb7b2473'));
    // }


    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }
}
